/**
 * O "Contexto" do painel da conversa (§5.1) — só dado real, pura:
 * cliente em foco, agente(s) do turno e as fontes consultadas na conversa.
 * Devolve `null` quando não há nenhum dos três (a seção some).
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila).
 */
import { rotuloDoAgente } from '@modules/aawz-intelligence-v2/constants/Hubs'
import { PAINEL_DO_CHAT } from '@modules/aawz-intelligence-v2/constants/TextChat'
import { agruparFontes } from '@modules/aawz-intelligence-v2/utils/fontes'

// Fontes visíveis antes do "+N".
export const MAX_FONTES_NO_CONTEXTO = 3

/**
 * O nome do cliente em foco. O resolvido pela IA (`clienteDaConversaAtual`)
 * só vale se for DESTA conversa — a mesma guarda de
 * `view-chat.vue::clienteDaConversaAtualValidado`; depois o escopo escolhido.
 */
export function nomeDoClienteEmFoco({ clienteDaConversa, idDaConversa, clienteEscopo } = {}) {
  const daConversa = clienteDaConversa
  const mesmaConversa = daConversa && (!idDaConversa || daConversa.conversation_id === idDaConversa)
  if (mesmaConversa && (daConversa.nome || daConversa.name)) {
    return daConversa.nome || daConversa.name
  }
  if (clienteEscopo) return clienteEscopo.name || clienteEscopo.nome || ''
  return ''
}

/** Rótulos únicos, na ordem, dos agentes com slug conhecido. */
export function rotulosDosAgentes(agentes) {
  const rotulos = []
  ;(agentes || []).forEach(function (agente) {
    const rotulo = agente ? rotuloDoAgente(agente.agentSlug) : ''
    if (rotulo && !rotulos.includes(rotulo)) rotulos.push(rotulo)
  })
  return rotulos
}

/** As fontes de TODAS as respostas do assistente, consolidadas por tabela. */
export function fontesDaConversa(mensagens) {
  const sources = []
  const lista = mensagens || []
  lista.forEach(function (mensagem) {
    if (!mensagem || mensagem.role !== 'assistant') return
    const fontes = mensagem.sources || []
    fontes.forEach(function (fonte) {
      sources.push(fonte)
    })
  })
  return agruparFontes(sources)
}

/**
 * @param {Object}   entrada
 * @param {string}   entrada.cliente       `nomeDoClienteEmFoco(...)`.
 * @param {Object[]} entrada.agentes       `[{agentSlug}]` do turno.
 * @param {Object[]} entrada.mensagens     `messages` do store.
 * @param {boolean}  entrada.mostraFontes  `persona.mostraFontes`.
 * @returns {null|{cliente: string, agentes: string[], fontes: Object[], fontesExcedentes: number}}
 * @example contextoDoPainel({ cliente: 'Ana', agentes: [], mensagens: [] })
 *   // → { cliente: 'Ana', agentes: [], fontes: [], fontesExcedentes: 0 }
 */
export function contextoDoPainel(entrada) {
  const config = entrada || {}
  const cliente = config.cliente || ''
  const agentes = rotulosDosAgentes(config.agentes)
  const todas = config.mostraFontes ? fontesDaConversa(config.mensagens) : []
  if (!cliente && !agentes.length && !todas.length) return null
  return {
    cliente: cliente || PAINEL_DO_CHAT.ESCRITORIO_INTEIRO,
    agentes: agentes,
    fontes: todas.slice(0, MAX_FONTES_NO_CONTEXTO),
    fontesExcedentes: Math.max(0, todas.length - MAX_FONTES_NO_CONTEXTO),
  }
}
